import { i18n } from "@/resources/locales";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import NotificationEvent from "../notifications/notificationEvent";

const ERROR_USER_BANNED = "Your user is banned.";
const ERROR_SPACE_USER_BANNED = "You are banned for this space.";
const ERROR_USER_DELETED = "Your user is deleted.";
const ERROR_SPACE_DISABLED = "This space is disabled.";
const ERROR_SPACE_DELETED = "This space is deleted.";
const ERROR_SPACE_USER_DELETED = "You user is deleted from this space.";
const ERROR_INVALID_CREDENTIALS = "Invalid credentials.";
const ERROR_ACCESS_DENIED = "Access Denied.";

const ERROR_400 = 400;
const ERROR_401 = 401;
const ERROR_403 = 403;
const ERROR_404 = 404;
const ERROR_422 = 422;

@Component({})
export default class ErrorController extends mixins(NotificationEvent) {
  checkError(error): void {
    switch (error.response.status) {
      case ERROR_422: {
        const violations = error.response.data.violations;
        if (violations.length >= 0) {
          this.onError(
            "",
            i18n.t("notifications.errorCode." + violations[0].code.toString())
          );
        } else this.genericError(error.response.status);
        break;
      }
      case ERROR_401: {
        if (error.response.data.message == ERROR_INVALID_CREDENTIALS)
          this.onError(
            "",
            i18n.t("notifications.errorMessages.invalidCredentials")
          );
        break;
      }
      case ERROR_403: {
        if (error.response.data.detail == ERROR_SPACE_DISABLED) {
          this.onError(
            "",
            i18n.t("notifications.errorMessages.spaceDisabled"),
            "none"
          );
          break;
        }
        if (error.response.data.detail == ERROR_USER_DELETED) {
          this.$store.dispatch("AuthStore/logOutAction");
          this.onError(
            "",
            i18n.t("notifications.errorMessages.userDelete"),
            "none"
          );
          break;
        }
        if (error.response.data.detail == ERROR_USER_BANNED) {
          this.$store.dispatch("AuthStore/logOutAction");
          this.onError(
            "",
            i18n.t("notifications.errorMessages.userBanned"),
            "none"
          );
          break;
        }
        if (error.response.data.detail == ERROR_SPACE_USER_BANNED) {
          this.onError(
            "",
            i18n.t("notifications.errorMessages.userSpaceBanned"),
            "none"
          );
          break;
        }
        if (error.response.data.detail == ERROR_SPACE_DELETED) {
          this.onError(
            "",
            i18n.t("notifications.errorMessages.spaceDelete"),
            "none"
          );
          break;
        }
        if (error.response.data.detail == ERROR_SPACE_USER_DELETED) {
          this.onError(
            "",
            i18n.t("notifications.errorMessages.spaceUserDelete"),
            "none"
          );
          break;
        }
        if (error.response.data.detail == ERROR_ACCESS_DENIED) {
          this.onError(
            "",
            i18n.t("notifications.genericError.genericErrorRetry"),
            "none"
          );
          localStorage.setItem("city", "ON");
          localStorage.removeItem("space_default");
          window.location.reload();
          //this.$store.dispatch("AuthStore/logOutAction");
          break;
        }
        this.onError(
          "",
          i18n.t("notifications.genericError.genericErrorRetry"),
          "none"
        );
        break;
      }
      default:
        this.genericError(error.response.status);
        break;
    }
  }
  genericError(code) {
    this.onError(
      "",
      i18n.t("notifications.genericError.genericError", { code })
    );
  }
}
